import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import styled from 'styled-components';
import { createSelector } from 'reselect';
import { Wizard } from './wizard';

const ContainerEl = styled.div`
  padding-bottom: 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
`;

const mapState = createSelector(
  ({ newCustomLayers }) => newCustomLayers,
  (newCustomLayers) => {
    const existingLayers = Object.values(newCustomLayers);
    const key = get(existingLayers, '[0].key');
    return {
      key,
    };
  }
);

export const LayerBuilderContainer = ({ setOpenNav }) => {
  const dispatch = useDispatch();
  const { key } = useSelector(mapState);

  useEffect(() => () => {
    dispatch({
      type: 'REMOVE_NEW_CUSTOM_LAYER',
      payload: { key },
    });

    dispatch({ type: 'DRAW_DISABLED' });
    dispatch({ type: 'CLEAR_DRAW_AREA' });
  }, [key, dispatch]);

  return (
    <ContainerEl>
      <Wizard setOpenNav={setOpenNav} />
    </ContainerEl>
  );
};
